import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { IS_LTI_APP } from "./utils/deployTarget";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { pdfjs } from "react-pdf";
import "react-quill-new/dist/quill.snow.css";
import AnalyticsConsent from "./components/AnalyticsConsent";
import { captureFirstTouchAttribution } from "./utils/attribution";
import { adoptSsoCookieIfNeeded } from "./utils/ssoCookie";


pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// public/index.html is shared across both Vercel builds, so set the standalone
// OSCE title at runtime rather than forking the static HTML.
if (IS_LTI_APP && typeof document !== "undefined") {
  document.title = "Standalone Simulator — StudyRadar";
}

// First-party attribution is captured independently of analytics consent and
// never prevents either application root from mounting.
captureFirstTouchAttribution();

// Cross-subdomain SSO: adopt a session left by a sibling *.studyradar.ai
// subdomain BEFORE the app mounts, so auth guards already see the token on
// first render (e.g. Moodle → lti.studyradar.ai after logging in on the app).
adoptSsoCookieIfNeeded();

// Lazy-load the two roots so each lands in its own chunk. The OSCE build only
// downloads OsceApp's chunk at runtime (and the full app only downloads App's),
// instead of bundling the entire product into both deploys.
const Root = lazy(() => (IS_LTI_APP ? import("./OsceApp") : import("./App")));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsConsent />
      <ChakraProvider value={defaultSystem}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <Suspense fallback={null}>
            <Root />
          </Suspense>
        </GoogleOAuthProvider>
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
